export const StatusBadge = ({ state, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 font-mono-alt text-[11px] uppercase tracking-[0.18em] ${
      state.open
        ? "border-[#2E7D4F]/30 bg-[#EAF5EE] text-[#2E7D4F]"
        : "border-[#E32219]/30 bg-[#E32219]/10 text-[#E32219]"
    }`}
  >
    <span
      className={`h-2 w-2 rounded-full ${state.open ? "bg-[#2E7D4F] pulse-dot" : "bg-[#E32219] pulse-dot-closed"}`}
    />
    {state.label}
  </span>
);
